/*
 * action types
 */

export const LOGIN_USER = "LOGIN_USER";
export const SELECT_BRANCH = "SELECT_BRANCH";
export const SELECT_CASHREGISTER = "SELECT_CASHREGISTER";
export const SELECT_POINTSALE = "SELECT_POINTSALE";
export const CLEAR_USER = "CLEAR_USER";
export const TOGGLE_THEME = "TOGGLE_THEME";

/*
 * action creators
 */

export const loginUser = (user) => ({ 
    type : LOGIN_USER,
    user
});

export const selectBranch = (business, branch, pv, cashRegister) => ({
    type : SELECT_BRANCH,
    business,
    branch,
    pv,
    cashRegister
})

export const selectCashRegister = (cashRegister) => ({
    type : SELECT_CASHREGISTER,
    cashRegister
})

export const selectPv = (pv) => ({
    type : SELECT_POINTSALE,
    pv
})

export const clearUser = () => ({
    type: CLEAR_USER
})

export const toggleTheme = (isLight) => ({
    type: TOGGLE_THEME,
    isLight
})